import React from "react";

import "./AlertModal.css";

//Paramètres
//Title => Titre dans l'entête => String
//Message => Message dans le corp => String
//Confirm => Texte du bouton cancel confirm => String
//onConfirm => OnClick du bouton confirm => function
//Display => Affichage ou non => bool
//Loading => Chargement en cours => bool


const AlertModal = (props) => {

  if (!props.Display) return null;

  return (
    <div className="alertmodal_page">
      <div className="alertmodal_cont">
        <div className="alertmodal_header">
          {props.Title}
        </div>
        <div className="alertmodal_body">
          {props.Message}
        </div>
        <div className="alertmodal_footer">
          <input
            type="button"
            className="page_button alertmodal_button"
            value={props.Confirm}
            onClick={props.onConfirm}
            disabled={props.Loading}
          />
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
